/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalibrationDataType = {
    LegacyTxt: 'LegacyTXT',
    Json: 'JSON'
} as const;
export type CalibrationDataType = typeof CalibrationDataType[keyof typeof CalibrationDataType];


export function CalibrationDataTypeFromJSON(json: any): CalibrationDataType {
    return CalibrationDataTypeFromJSONTyped(json, false);
}

export function CalibrationDataTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataType {
    return json as CalibrationDataType;
}

export function CalibrationDataTypeToJSON(value?: CalibrationDataType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the CalibrationDataType interface.
 */
 export function instanceOfCalibrationDataType(value: any): value is CalibrationDataType {
    return Object.values(CalibrationDataType).includes(value)
}

